<template>
<transition name="move">
  <div class="choose-date" v-if="show">

    <div class="date-wrapper">
        <div class="date-row">
            <span class="date-item" v-for="(list, index) in dateArr" :key="index" @click="bindActive(index,list)" :class="{active: currentIndex === index}">
                {{list}}个月
            </span>
        </div>   
    </div>

    <button class="other-btn" v-if="show_other_date" @click="chooseElse">{{otherDate}}</button>
    <button class="sub-btn" @click="subInfo">提交</button>
    
    <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="new Date()" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日"></mt-datetime-picker>

  </div>
</transition>
</template>
<script>
import {MessageBox} from 'mint-ui';
export default {
  props: [
    'startTime',
    'roomId',
    'vToken',
    'userId',
    'feeToken'
  ],
  data () {
    return {
        show: false, // 是否被显示
        dateArr: [],
        currentIndex: 0,
        selectMonth:0,
        stampStamp:0,
        otherDate: '其他', // 其他日子
        all_month:['1','2','3','4','5','6','7','8','9','10','11','12','13'],
        s_date:'其他',
        show_other_date:0
    }
  },
  created () {
     //获取父组件里面的内容
    
     //this.stampStamp = Date.parse(this.startTime);
    
  },
  methods: {
    // 控制此页面的显示隐藏
    showDate() {
      
         
         this.$indicator.open();
         this.axios.get('/jmobile/WxApi/showTime/room_id/'+this.roomId+'/start_time/'+this.startTime+'/token/'+this.vToken+'/user_id/'+this.userId+'/fee_token/'+this.feeToken+'/is_share/true').then((res)=>{
            this.$indicator.close();
         
            if(res.data.status == '1'){
                this.dateArr = this.subSet(this.all_month,res.data.data.month);
                this.show = true;
            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'3000'
                });
            }
         }).catch((response)=>{
            this.$toast({
                message:response.data.info,
                position:'bottom',
                duration:'3000'
            })
         })
    },
    // 选择其他日子
    chooseElse () {
        this.$refs.picker.open();
    },
    // 将其他替换成选择的日期
    handleConfirm (value) {
        let year = value.getFullYear();
        let month = value.getMonth() + 1;
        let day = value.getDate();
        this.otherDate = `${year}-${month}-${day}`;
        this.selectMonth = '',
        this.s_date = this.otherDate;
    },
    // 月份高亮
    bindActive (index,value) {
        this.currentIndex = index;
        this.selectMonth = value;

    },
    subSet(arr1,arr2){
        let set1 = new Set(arr1);
        let set2 = new Set(arr2);
        let subset = [];
        for(let item of set1){
            if(!set2.has(item)){
                subset.push(item);
            }
        }
        if(set2.has('0')){
            this.show_other_date = 0;
        }else{
            this.show_other_date = 1;
        }
        return subset;
    },
    // 提交按钮 来控制日期组件的消失
    subInfo () {
        let qs = require('querystring');

       // console.log(this.startTime);
       
       this.$indicator.open();
        var data={s_month:this.selectMonth,s_date:this.s_date};
        var url = '/jmobile/WxApi/createTmpOrder/room_id/'+this.roomId+'/start_time/'+this.startTime+'/token/'+this.vToken+'/user_id/'+this.userId+'/fee_token/'+this.feeToken+'/is_share/true';
        this.axios.post(url,data).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
                 this.$emit('themonth', {end_time:res.data.data.end_time});
                 this.show = false;   
            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                })
            }
        }).catch((response)=>{
            this.$indicator.close();
            this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'2000'
            });
        })
    }
  }
}
</script>
<style lang="less">
.choose-date{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 22px 15px 0;
    z-index: 999;
    width: 100%;
    font-size: 16px;
    background: #fff;
    .date-wrapper{
        .date-row{
            display: flex;
            flex-wrap: wrap;
            .date-item{
                flex: 1;
                margin-bottom: 23px;
                margin-right: 5px;
                color: #5a585b;
                height: 40px;
                line-height: 40px;
                text-align: center;
                min-width: 30%;
                max-width: 32%;
                border: 1px solid #dcdcdc;
                border-radius: 5px;
                &.active{
                    border-color: #feca68;
                }
                &:nth-child(3n){
                    margin-right: 0px;
                }
            }
        }
    }
    button{
        width: 100%;
        border-radius: 5px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 16px;
    }
    .other-btn{
        margin: 5px 0 10px;
        color: #fff;
        background: #c5c5c5;
    }
    .sub-btn{
        color: #fff;
        background: #ffaf14;
    }
}
.move-enter-active, .move-leave-active {
    transition: all .5s;
}
.move-enter, .move-leave-to {
    transform: translate3d(100%, 0, 0);
}
</style>




// WEBPACK FOOTER //
// src/components/ChooseDate.vue